import { IIntroValues } from '../types/redux/intro';

export const isSpecialIntoCase = (intro: IIntroValues) => {
  return [intro.fromN1, intro.fromSaleRent, intro.fromBankiru, intro.fromAlfaBank].some(value => value === true);
};
